import {Add, Check} from '@mui/icons-material';
import {Stack, Typography} from '@mui/material';
import React from 'react';
import {IChild} from './TypesHeatMap';
import ArrIconButton from '../../../common/arr-icon-button/ArrIconButton';
import {t} from 'i18next';

interface ITiles {
  item: IChild;
  isSelected?: boolean;
  setSelectedCluster: React.Dispatch<
    React.SetStateAction<{[key: number]: string | null}>
  >;
  currentLevelIndex: number;
  cartItems: IChild[];
  setCartItems: React.Dispatch<React.SetStateAction<IChild[]>>;
  dataTestId?: string;
}
const Tiles = ({
  item,
  isSelected,
  setSelectedCluster,
  currentLevelIndex,
  cartItems,
  setCartItems,
  dataTestId,
}: ITiles) => {
  console.log('child', item);
  const handleCart = (e: React.MouseEvent) => {
    e.stopPropagation();
    setCartItems((prevItems) => [...prevItems, item]);
  };
  const handleKeyDown = (e: React.KeyboardEvent) => {
    e.stopPropagation();
    if (e.key === 'Enter' || e.key === ' ') {
      setSelectedCluster((prev) => ({
        ...prev,
        [currentLevelIndex]:
          prev[currentLevelIndex] === item.id ? null : item.id,
      }));
    }
  };
  return (
    <>
      <Stack className={'icon'}>
        {isSelected ? (
          <ArrIconButton
            size="small"
            ariaLabel={t(
              'reports.dataAnalysisReport.conceptExplorer.heatedMapAriaLabel.unselect'
            )}
            className="added"
            icon={<Check />}
            tabIndex={0}
            testId={`tiles-unselect-icon-button-${dataTestId}`}
          />
        ) : (
          <ArrIconButton
            size="small"
            ariaLabel={t(
              'reports.dataAnalysisReport.conceptExplorer.heatedMapAriaLabel.addToCart'
            )}
            className={`add ${Number(item?.hdocs || 0) > 0 && 'add-dark'}`}
            icon={<Add />}
            style={{
              display:
                !isSelected &&
                cartItems.some((cartItem) => cartItem.id === item.id)
                  ? 'none'
                  : 'flex',
            }}
            tabIndex={0}
            onClick={handleCart}
            testId={`tiles-add-to-cart-icon-button-${dataTestId}-${currentLevelIndex}`}
          />
        )}
      </Stack>
      <Typography
        className={`typo_text body3_size ${
          isSelected
            ? ''
            : cartItems.find((cartItem) => cartItem.id === item.id)
              ? 'cart-item-text'
              : 'inverse-heading'
        }`}
        tabIndex={0}
        onKeyDown={handleKeyDown}
        data-testid={`tiles-name-${dataTestId}-${currentLevelIndex}`}
      >
        {item.name}
      </Typography>
    </>
  );
};

export default Tiles;
